import React, { FC, MouseEventHandler, RefObject } from 'react';
import { ITabBarButtonTitleProps, TabBarButtonTitle } from '../ButtonTitle/TabBar-ButtonTitle';
import { ITabBarButtonIconProps, TabBarButtonIcon } from '../ButtonIcon/TabBar-ButtonIcon';
require("./TabBar-Button.css");
var styles = {
  "Root": "TabBar-Button-module-Root_5-w",
  "TabBarButtonIconContainer": "TabBar-Button-module-TabBarButtonIconContainer_2df"
};
export const TabBarButton = ({
  text,
  defaultIcon,
  onClick,
  href,
  isActive,
  controlRef,
  iconContainerChildren,
  buttonElement = 'a'
}) => {
  const ButtonElement = buttonElement;
  return /*#__PURE__*/React.createElement(ButtonElement, {
    className: styles.Root,
    disabled: isActive,
    href: href,
    onClick: onClick,
    ref: controlRef
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.TabBarButtonIconContainer
  }, /*#__PURE__*/React.createElement(TabBarButtonIcon, {
    defaultIcon: defaultIcon,
    isActive: isActive
  }), iconContainerChildren), /*#__PURE__*/React.createElement(TabBarButtonTitle, {
    text: text,
    isActive: isActive
  }));
};